import React, {useState} from 'react'
import styles from './styles'
import breakingNews from '../../../../images/breakingnews.svg'
// import ArrowDown from '../../../../images/downCaret.svg'
// import ArrowUp from '../../../../images/upCaret.svg'
// import ArrowUpWhite from '../../../../images/upWhiteCaret.svg'
// import ArrowDownWhite from '../../../../images/downWhiteCaret.svg'
import { Grid, Typography } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import { useTheme } from '@material-ui/core/styles';
import { emulatorScreen, mobileScreen } from "../../../../utils/styleUtils"
import useMediaQuery from '@material-ui/core/useMediaQuery';
import 'animate.css/animate.css'

const BreakingNews = ({ questionAnswer, selectedOption, setSelectedOption, submitPart2, classes }) => {
  // const [selectedOption, setSelectedOption] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(mobileScreen(theme));

  console.log("mobileScreen", isMobile  )
  return (
    <Grid style={{ display: "flex", justifyContent: 'center', alignItems: "center", flexDirection: 'column' }}>
      <Grid className={`${classes.questionContainer} animate__animated animate__bounceIn`} style={{ padding: submitPart2 === 1 && '10px 15px' }}>
        <Grid className={classes.questionBody}>
          {submitPart2 !== 1 && <img src={breakingNews} className={classes.breakingNews}></img> }
          {submitPart2 !== 1 &&  <img src={questionAnswer.icon} className={classes.circleIcon}></img>}
          <Typography variant='h5' className={classes.questionText} style={{ paddingTop: submitPart2 === 1 && 0, fontSize: isMobile ? 12 : submitPart2 === 1 && 22   }}>
            {submitPart2 === 1 ? questionAnswer.step2.question : questionAnswer.question}
          </Typography>

          <Typography variant='h5' className={classes.subQuestionText} style={{ fontSize: isMobile ? 14 : submitPart2 === 1 && 22 }}>
            { submitPart2 === 1 ? questionAnswer.step2.followUpQuestion : questionAnswer.subQuestion}
          </Typography>
        </Grid>
      </Grid>
      {submitPart2 === 1 &&
      <Grid className={classes.optionQuestionContainer}>
        {/* <Typography
          varient="h5"
          className={`${classes.optionQuestion} animate__animated animate__bounceIn`}
        >
          {questionAnswer.step2.followUpQuestion}
        </Typography> */}
        <Grid className={classes.optionQuestionBody}>
          {questionAnswer.step2.options.map((option, i) => (
            <Typography
              varient="h3"
              style={{
                color: selectedOption === option ? "#fff" : "#003E4C",
                backgroundColor:
                  selectedOption === option ? "#003E4C" : "#ecf2f1",
              }}
              className={classes.optionChoices}
              onClick={() => setSelectedOption(option)}
            >
              {option}
            </Typography>
          ))}
        </Grid>
      </Grid>
      }
    </Grid>
  )
}

export default withStyles(styles)(BreakingNews)
